import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import TitleProject from '../TitleProject'
import moment from 'moment'

import './ListArticle.css'

const itemArticle = (data, navigate, getScroll) => {
	const { date, title, urlPage } = data

	return (
		<Grid item container className='article-item' key={urlPage}>
			<Button onClick={() => navigate(`/blog/${urlPage}?scroll=${getScroll()}`)}>
				<Grid item container className='article-item__container'>
					<Grid item className='article-item__container__date'>
						{`${moment(date).format('DD')} ${moment(date).format('MMMM')} ${moment(date).format('YYYY')}`}
					</Grid>
					<Grid item className='article-item__container__title'>
						<TitleProject title={title} />
					</Grid>
				</Grid>
			</Button>
		</Grid>
	)
}

const ListArticle = ({ data, long }) => {
	const navigate = useNavigate()

	const getScroll = () => window.scrollY

	return (
		<Grid container justifyContent="center" alignItems="center" style={{padding: "20px 0 0 0"}}>
      		<Grid item container xs={11} justifyContent="space-evenly" alignItems="center">
				{
					data.map((dataElement, i) => {
						if (Number.parseInt(long) !== -1 && i >= Number.parseInt(long)) {
							return
						}

						return itemArticle(dataElement, navigate, getScroll)
					})
				}
      		</Grid>
    	</Grid>
	)
}

export default ListArticle